import { ContentItem } from '@/types/contentTree'

export function wasContentRecentlyCreated(content: ContentItem) {
  const SIXTY_DAYS_AS_MILLISECONDS = 1000 * 60 * 60 * 24 * 60
  const creationTimestamp = new Date(
    content.created_at || '2024-01-01'
  ).getTime()
  return Date.now() - creationTimestamp <= SIXTY_DAYS_AS_MILLISECONDS
}

export function wasContentRecentlyUpdated(content: ContentItem) {
  const SIXTY_DAYS_AS_MILLISECONDS = 1000 * 60 * 60 * 24 * 60
  const updateTimestamp = new Date(content.updated_at || '2024-01-01').getTime()
  return Date.now() - updateTimestamp <= SIXTY_DAYS_AS_MILLISECONDS
}
